import { API_BASE_URL } from '../config/api';

class EmailService {
    async sendEmail(emailData) {
        try {
            const response = await fetch(`${API_BASE_URL}/api/email/send`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify(emailData)
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || data.error || 'Failed to send email');
            }

            return data;
        } catch (error) {
            console.error('Email service error:', error);
            throw error;
        }
    }

    async testSMTPConfig() {
        try {
            const response = await fetch(`${API_BASE_URL}/api/email/test`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include'
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || data.error || 'SMTP test failed');
            }

            return data;
        } catch (error) {
            console.error('SMTP test error:', error);
            throw error;
        }
    }
}

const emailService = new EmailService();
export default emailService;
